import { PracticePitcherSingleSessionReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const PracticePitcherSingleSessionPitchByPitchStatsChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PracticePitcherSingleSessionPitchByPitchStatsChart'
      configKey='practicePitcherSingleSessionPitchByPitchStatsChartConfig'
      {...props}
    />
  );
};

export default PracticePitcherSingleSessionPitchByPitchStatsChartSidebar;
